import { createContext, useContext } from 'react'
import type { CallSnapshot, MediaDevice } from './call.types'

export interface CallControls {
  preview: () => void
  join: () => void
  setMic: (on: boolean) => void
  setCam: (on: boolean) => void
  setScreen: (on: boolean) => void
  leave: () => Promise<void>
  /** Device menu. listDevices resolves [] when the provider has no device API. */
  listDevices: () => Promise<MediaDevice[]>
  setCamera: (deviceId: string) => void
  setMicrophone: (deviceId: string) => void
  setSpeaker: (deviceId: string) => void
}

export interface CallContextValue {
  snapshot: CallSnapshot
  controls: CallControls
}

export const CallContext = createContext<CallContextValue | null>(null)

export function useCall(): CallContextValue {
  const value = useContext(CallContext)
  if (!value) throw new Error('useCall must be used within CallProvider')
  return value
}
